<template>
  <div class="wrapper box  box_v">
    <page-head title="防疫设置" :show-back="true">
    </page-head>
    <Card class="card-wrapper1">
      <div class="box set-content">
        <div class="box set-item">
          <div class="box_f1 set-title">表单设置</div>
          <div class="box_f1 set-shuoming">说明: 可设置民生通小程序社区防疫表单的内容</div>
          <div class="box_f1 set-edit" @click="$router.push({ name: 'epidemicSet'})">
            <i class="iconfont icon-bianji1"></i>
            编辑
          </div>
        </div>
      </div>
      <div class="box set-content">
        <div class="box set-item">
          <div class="box_f1 set-title">温馨提示设置</div>
          <div class="box_f1 set-shuoming">说明: 可设置民生通小程序社区防疫温馨提示的内容</div>
          <div class="box_f1 set-edit" @click="$router.push({ name: 'epidemicNotice'})">
            <i class="iconfont icon-bianji1"></i>
            编辑
          </div>
        </div>
      </div>
      <div class="box set-content">
        <div class="box set-item">
          <div class="box_f1 set-title">登记卡设置</div>
          <div class="box_f1 set-shuoming">说明：可设置登记卡中便民信息及落款</div>
          <div class="box_f1 set-edit" @click="$router.push({ name: 'epidemicPeopleCard'})">
            <i class="iconfont icon-bianji1"></i>
            编辑
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
  import pageHead from '../../../components/head'

  export default {
    name: 'set',
    components: {
      pageHead
    },
    data() {
      return {}
    }
  }
</script>

<style lang="less" scoped>
  .wrapper{
    height: 100%
  }
  .card-wrapper1 {
    height: 100%;
    margin: 0 20px 20px 20px;
  }
  .set-content {
    width: 100%;
    padding-bottom: 30px;
    padding-top: 30px;
    border-bottom: 1px solid #eee;
  }
  .set-item {
    width: 70%;
  }
  .set-title {
    font-size: 18px;
  }
  .set-shuoming {
    margin-left: -20%;
    font-size: 16px;
  }
  .set-edit {
    font-size: 16px;
    color: #677a9e;
  }
  /deep/ .ivu-card-body {
    padding-top: 0;
    padding-right: 0;
  }
</style>
